export const isTargetingAllowed = () => window?.OnetrustActiveGroups?.includes('C0004') || false;
